import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import { useMemo } from 'react'
import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { PairMigrationStatus } from '@root/entities/pair'
import { PairLink } from '@root/entities/pair/ui/common'
import { DATE_FORMAT } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const CreatorPairsTableMigratedCell: React.FC<Props> = ({ pair }) => {
  const [migrationStatus] = useAtom(pair.migrationStatus)
  const { t } = useTranslation()

  const isMigrated = PairMigrationStatus.isMigrated(migrationStatus)

  const tooltipContent = useMemo(() => {
    if (migrationStatus instanceof PairMigrationStatus.MigratedFrom) {
      return t('pair.token-migrated-tooltip', {
        timestamp: DateF.format(
          migrationStatus.migration.migrationTimestamp,
          DATE_FORMAT.dd_MM_yy__HH_mm,
        ),
      })
    }
    return undefined
  }, [migrationStatus, t])

  return (
    <Tooltip content={tooltipContent}>
      <Root pair={pair} data-migrated={isMigrated}>
        {isMigrated ? t('common.yes') : t('common.no')}
      </Root>
    </Tooltip>
  )
}

const Root = styled(PairLink<PairModel>)`
  pointer-events: auto;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  &[data-migrated='true'] {
    color: var(--success-9);
  }
  &[data-migrated='false'] {
    color: var(--error-9);
  }
`
